import React, { useEffect, useState } from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Button,
  Form,
  Label,
  FormFeedback,
  Input,
} from "reactstrap"
import ReactQuill from "react-quill-new"
import "react-quill-new/dist/quill.snow.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import leftArrow from "../../assets/images/icons/left-arrow.svg"
import LoaderComponent from "components/loader"
import {
  useEditBlogMutation,
  useLazyGetBlogByIdQuery,
} from "store/api/blogs/blog"
import Spinners from "components/Common/Spinner"
import * as Yup from "yup"
import { useFormik } from "formik"
import toast from "react-hot-toast"
import Breadcrumb from "components/Common/Breadcrumb"

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  // ["blockquote", "code-block"],
  ["link", "image"],
  [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
  // [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ["clean"],
]

const BlogEdit = ({ user_type }) => {
  const { id } = useParams()
  const [getResult, { isFetching }] = useLazyGetBlogByIdQuery()
  const [updateBlog, { isFetching: isUpdating }] = useEditBlogMutation()
  const navigate = useNavigate()

  document.title = "Blog Details | Prachay"

  const getBlogData = async () => {
    try {
      const { success, data } = await getResult({ id }).unwrap()
      if (success) {
        validation.setFieldValue("title", data.title)
        validation.setFieldValue("blog", data.blog)
        validation.setFieldValue("status", data.status)
      }
    } catch (error) {}
  }

  const editBlog = async (values) => {
    try {
      const { success, message } = await updateBlog({
        id,
        ...values,
        user_type,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "blogSuccess" })
        navigate(user_type === "INVESTOR" ? "/resources/blogs" : "/wp-blogs")
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  useEffect(() => {
    if (id) {
      getBlogData()
    }
  }, [id])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { title: "", status: "", blog: "" },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      await editBlog(values)
    },
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl={12}>
              <Breadcrumb title={"Update Blog"} />
              <Card>
                {isFetching ? (
                  <LoaderComponent />
                ) : (
                  <CardBody className="pt-4">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <div className="d-flex align-items-center mb-4 justify-content-between pt-4"></div>
                      <Row className="mb-2">
                        <Col sm={6} className="mb-2">
                          <Label className="form-label">
                            Title<span className="error">*</span>
                          </Label>
                          <Input
                            name="title"
                            className="form-control"
                            placeholder={"Enter Title"}
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.title}
                            invalid={
                              validation.touched.title &&
                              validation.errors.title
                            }
                          />
                          {validation.touched.title &&
                          validation.errors.title ? (
                            <FormFeedback type="invalid">
                              {validation.errors.title}
                            </FormFeedback>
                          ) : null}
                        </Col>

                        <Col xl={6} className="mb-2">
                          <Label className="form-label">
                            Status<span className="error">*</span>
                          </Label>
                          <select
                            name="status"
                            className="form-select pageSize mb-2"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.status}
                          >
                            <option>Select Status</option>
                            {[
                              { label: "ACTIVE", value: "ACTIVE" },
                              { label: "DISABLE", value: "DISABLE" },
                            ].map((item, index) => (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                          {validation.touched.status &&
                          validation.errors.status ? (
                            <FormFeedback type="invalid">
                              {validation.errors.status}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>

                      <Row className="mb-2">
                        <Col sm={12}>
                          <ReactQuill
                            theme="snow"
                            value={validation.values.blog}
                            onChange={(e) =>
                              validation.setFieldValue("blog", e)
                            }
                            placeholder="Enter Blog Content..."
                            modules={{
                              toolbar: toolbarOptions,
                            }}
                          />{" "}
                          {validation.touched.blog && validation.errors.blog ? (
                            <FormFeedback type="invalid">
                              {validation.errors.blog}
                            </FormFeedback>
                          ) : null}
                        </Col>
                      </Row>

                      <Row className="justify-content-end mt-4">
                        <Col sm={12}>
                          <div className="d-flex justify-content-end align-items-center gap-3">
                            {/* <Link to={"/icd"}>
                            <button
                              // type="submit"
                              className="btn btn-cancel w-md"
                            >
                              Cancel
                            </button>
                          </Link> */}
                            <Button
                              type="submit"
                              className="btn btn-primary w-md"
                              disabled={isUpdating}
                            >
                              {isUpdating ? <Spinners /> : "Update blog"}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BlogEdit
